import { css, Global } from "@emotion/react";
import { useEffect, useState } from "react";
import getBaseUrl from "../../lib/utils/getBaseUrl";
import Fundamentei from "../branding/Fundamentei";
import * as palette from "../palette";

export default function WholePageLoadingBlankslate() {
  const [tryToRefreshManually, setShowTryToRefreshManually] = useState(false);

  useEffect(() => {
    const tryToRefreshManuallyTimeout = setTimeout(() => setShowTryToRefreshManually(true), 6000);
    return () => clearTimeout(tryToRefreshManuallyTimeout);
  }, []);

  return (
    <>
      <Global
        styles={css`
          html,
          body {
            height: 100%;
          }
        `}
      />

      <div
        css={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          backgroundColor: palette.selago,
        }}
      >
        <div
          css={{
            display: "grid",
            gridRowGap: 18,
            textAlign: "center",
          }}
        >
          <div>
            <Fundamentei width={106} height={101} fill={palette.royalBlue} />
          </div>

          <h1
            css={{
              margin: 0,
              color: palette.royalBlue,
              fontWeight: "bold",
            }}
          >
            {tryToRefreshManually ? "Aguarde :(" : "Aguarde..."}
          </h1>

          {tryToRefreshManually && (
            <p
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontWeight: 500,
                fontSize: 16,
                lineHeight: 1.33,
                letterSpacing: 1,
              }}
            >
              {"Investidor—caso essa página permaneça por muito tempo, "}
              <a
                title="Atualizar página"
                href={getBaseUrl()}
                css={{
                  textDecoration: "underscore",
                  color: palette.link,
                }}
              >
                tente atualizar manualmente.
              </a>
            </p>
          )}
        </div>
      </div>
    </>
  );
}
